import React, { useState, useEffect } from "react";
import { getDomains } from "../api/api";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import MyLocationIcon from "@mui/icons-material/MyLocation";

// Fix missing marker icons in Leaflet
import L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

const defaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});


const LocationButton = () => {
  const map = useMap();

  const handleLocationClick = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          map.setView([latitude, longitude], 8);
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  return (
    <div
      onClick={handleLocationClick}
      style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        zIndex: 1000,
        backgroundColor: 'white',
        border: '2px solid rgba(0,0,0,0.2)',
        borderRadius: '4px',
        cursor: 'pointer',
        width: '34px',
        height: '34px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <MyLocationIcon style={{ fontSize: '20px', color: '#666' }} />
    </div>
  );
};

const MapComponent = () => {
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    const loadDomains = async () => {
      try {
        const domains = await getDomains();
        // Get current URL parameters
        const currentSearch = window.location.search;
        
        const formattedMarkers = domains.map(domain => ({
          id: domain._id,
          lat: domain.location.coordinates[1],
          lng: domain.location.coordinates[0],
          url: `https://${domain.domain}.${window.BASE_DOMAIN}${currentSearch}`,
          title: domain.name,
          domain: domain.domain
        }));
        setMarkers(formattedMarkers);
      } catch (error) {
        console.error('Error loading domains:', error);
      }
    };

    loadDomains();
  }, []);
  return (
    <MapContainer center={[50, -90]} zoom={4} style={{ height: "100%", width: "100%" }}>
      <LocationButton />
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {markers.map((marker) => (
        <Marker key={marker.id} position={[marker.lat, marker.lng]} icon={defaultIcon}>
          <Popup>
            <a 
              href={marker.url}
              onClick={() => {
                // Save domain to localStorage
                localStorage.setItem('hd', marker.domain);
              }}
            >
              {marker.title}
            </a>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default MapComponent;
